import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {EnvCtxProvider} from "./contexts/EnvCtx";
import {CameraCntxProvider} from "./contexts/CameraCntx";
import "bootstrap/dist/css/bootstrap.min.css";

const root = ReactDOM.createRoot(document.getElementById('root'));

if(process.env.NODE_ENV === 'development'){
    window.prmeLocationOrigin = "http://localhost:8080/prmeWeb";
} else{
    window.prmeLocationOrigin = window.location.origin+"/prmeWeb";
}

root.render(
    <React.StrictMode>
        <EnvCtxProvider>
            <Suspense fallback={<div>Loading....</div>}>
                <CameraCntxProvider>
                    <App />
                </CameraCntxProvider>
            </Suspense>
        </EnvCtxProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
